import { Keyword, List, Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Err, Result } from "@siteimprove/alfa-result";
import { Longhand } from "../longhand.js";
const { either } = Parser;
/**
 * @internal
 */
export const parseVariant = Keyword.parse("jis78", "jis83", "jis90", "jis04", "simplified", "traditional");
/**
 * @internal
 */
export const parseWidth = Keyword.parse("proportional-width", "full-width");
/**
 * @internal
 */
const parseEastAsian = (input) => {
    let variant;
    let width;
    let ruby;
    while (true) {
        for (const [remainder] of Token.parseWhitespace(input)) {
            input = remainder;
        }
        if (variant === undefined) {
            const result = parseVariant(input);
            if (result.isOk()) {
                [input, variant] = result.get();
                continue;
            }
        }
        if (width === undefined) {
            const result = parseWidth(input);
            if (result.isOk()) {
                [input, width] = result.get();
                continue;
            }
        }
        if (ruby === undefined) {
            const result = Keyword.parse("ruby")(input);
            if (result.isOk()) {
                [input, ruby] = result.get();
                continue;
            }
        }
        break;
    }
    if (variant === undefined && width === undefined && ruby === undefined) {
        return Err.of("At least one East Asian variant value must be provided");
    }
    return Result.of([
        input,
        List.of([variant, width, ruby].filter((value) => value !== undefined), " "),
    ]);
};
const parse = either(Keyword.parse("normal"), parseEastAsian);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant-east-asian}
 * @internal
 */
export default Longhand.of(Keyword.of("normal"), parse, (numeric) => numeric, { inherits: true });
//# sourceMappingURL=font-variant-east-asian.js.map